var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"estimate-paper"}},[_vm._l((_vm.cart.packs),function(pack,index){return _c('pack',{key:'pack-' + index,attrs:{"sizes":_vm.sizes,"basePrice":_vm.basePrice,"pack":pack,"index":index},on:{"packInput":_vm.packInput,"deletePack":function($event){return _vm.deletePack(index)}}})}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }